const appendChildren = (el, children) => {
  if (typeof children === 'string') {
    el.appendChild(document.createTextNode(children));
  } else if (children) {
    if (Array.isArray(children)) {
      children.forEach((child) => appendChildren(el, child));
    } else {
      el.appendChild(children);
    }
  }
};

const addProps = (el, props) => {
  Object.keys(props || {}).forEach((key) => {
    if (key === 'class' || key === 'className') {
      el.className = props[key];
    } else if (key.indexOf('on') === 0) {
      el.addEventListener(key.substring(2).toLowerCase(), props[key]);
    } else {
      el[key] = props[key];
    }
  });
};

// single element or function component
export const jsx = (tag, { children, ...props }) => {
  if (typeof tag === 'string') {
    // normal html
    const el = document.createElement(tag);
    addProps(el, props);
    appendChildren(el, children);
    return el;
  } else if (typeof tag === 'function') {
    // function component
    if (props.class) props.className = props.class; // don't use class
    return tag({ ...props, children });
  }
};

export const jsxs = jsx;
